import { render, staticRenderFns } from "./Pemrakarsa.vue?vue&type=template&id=162f71c3&"
import script from "./Pemrakarsa.vue?vue&type=script&lang=js&"
export * from "./Pemrakarsa.vue?vue&type=script&lang=js&"
import style0 from "./Pemrakarsa.vue?vue&type=style&index=0&id=162f71c3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports